/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import axios from "axios";
import router from "../../router";

const normalApiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
const llaApiBaseUrl = process.env.VUE_APP_LLA_API_BASE_URL;

const normalRequest = axios.create({
  baseURL: normalApiBaseUrl,
});
const normalRequestLLA = axios.create({
  baseURL: llaApiBaseUrl,
});

// 請求處理
normalRequest.interceptors.request.use(
  (config) => {
    config.headers.admin = "admin"; // 因為api的get方法不限權限，加入這個讓後端知道是管理平台的請求，如果沒登入會回傳403。
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);

// 回傳處理
normalRequest.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err.response.status === 403) {
      router.push({ name: "login" });
    }
    return Promise.reject(err);
  }
);
normalRequestLLA.interceptors.request.use(
  (config) => {
    config.headers.admin = "admin"; // 因為api的get方法不限權限，加入這個讓後端知道是管理平台的請求，如果沒登入會回傳403。
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);

// 回傳處理
normalRequestLLA.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err.response.status === 403) {
      router.push({ name: "login" });
    }
    return Promise.reject(err);
  }
);

export const C_Lecturer_GetList = () => normalRequestLLA.get("Lecturer_/list");
export const C_Lecturer_Get = (id) => normalRequestLLA.get(`Lecturer_/${id}`);
export const C_Lecturer_Update = (id, data) => normalRequestLLA.put(`Lecturer_/${id}`, data);
export const C_Lecturer_UpdateList = (data) => normalRequestLLA.put("Lecturer_/list", data);
export const C_Lecturer_Add = (data) => normalRequestLLA.post("Lecturer_/", data);
export const C_Lecturer_DeleteList = (data) => normalRequestLLA.post("Lecturer_/delete", data);

export const C_NewsCategory_GetList = () => normalRequestLLA.get("NewsCategory_/list");

export const C_Certificate_PhotoImport = (data) => normalRequestLLA.put("Certificate_/photoImport", data);
export const C_Certificate_GetList = (userId) => normalRequestLLA.get(`Certificate_/certlist/${userId}`);
export const C_Certificate_Update = (id, data) => normalRequestLLA.put(`Certificate_/${id}`, data);

export const C_News_Add = (data) => normalRequestLLA.post("News_", data);
export const C_News_GetList = (categoryId) => normalRequestLLA.get(`News_/list/${categoryId}`);
export const C_News_Update = (id, data) => normalRequestLLA.put(`News_/${id}`, data);
export const C_News_Delete = (id) => normalRequestLLA.delete(`News_/${id}`);
export const C_News_GetHtml = (id) => normalRequestLLA.get(`News_/html/${id}`);

export const C_CourseCategory_GetList = () => normalRequestLLA.get("CourseCategory_/list");

export const C_Course_Add = (data) => normalRequestLLA.post("Course_", data);
export const C_Course_GetList = (categoryId) => normalRequestLLA.get(`Course_/list/${categoryId}`);
export const C_Course_Update = (id, data) => normalRequestLLA.put(`Course_/${id}`, data);
export const C_Course_Delete = (id) => normalRequestLLA.delete(`Course_/${id}`);

export const C_TrainingRecord_GetBackList = (userId) => normalRequestLLA.get(`TrainingRecord_/backList/${userId}`);
export const C_TrainingRecord_Add = (data) => normalRequestLLA.post("TrainingRecord_", data);
export const C_TrainingRecord_Update = (data) => normalRequestLLA.post("TrainingRecord_/update", data);
export const C_TrainingRecord_DeleteList = (data) => normalRequestLLA.post("TrainingRecord_/delete", data);
export const C_TrainingRecord_UpdateExpiryDate = (data) => normalRequestLLA.put(`TrainingRecord_/expiry/${data}`);

export const C_ExpiryDate_Get = () => normalRequestLLA.get("TrainingRecord_/expiry/");

export const C_ReTrainingRecord_UpdateExpiryDate = (data) => normalRequestLLA.put(`ReTrainingRecord_/expiry/${data}`);
export const C_ReTrainingRecord_GetBackList = (userId) => normalRequestLLA.get(`ReTrainingRecord_/backList/${userId}`);
export const C_ReTrainingRecord_Add = (data) => normalRequestLLA.post("ReTrainingRecord_", data);
export const C_ReTrainingRecord_Update = (data) => normalRequestLLA.put("ReTrainingRecord_", data);
export const C_ReTrainingRecord_DeleteList = (data) => normalRequestLLA.post("ReTrainingRecord_/delete", data);

export const C_UserInfo_AddOne = () => normalRequestLLA.get("UserInfo_/addOne/");
export const C_UserInfo_UTRCList = () => normalRequestLLA.get("UserInfo_/UTRCList/");
export const C_UserInfo_Excel = (num) => normalRequestLLA.get(`UserInfo_/excel/${num}`);
export const C_UserInfo_ExportUrl = `${llaApiBaseUrl}UserInfo_/export/`;
export const C_UserInfo_Import = (data) => normalRequestLLA.post("UserInfo_/import", data);
export const C_UserInfo_GetUserInfo = (userId) => normalRequestLLA.get(`UserInfo_/userInfo/${userId}`);
export const C_UserInfo_Update = (userId, data) => normalRequestLLA.put(`UserInfo_/${userId}`, data);
export const C_UserInfo_DeleteList = (data) => normalRequestLLA.post("UserInfo_/delete", data);

export const C_UserInfo_Repeat = (data) => normalRequestLLA.post("UserInfo_/repeat", data);
export const C_UserInfo_AddTR = (data) => normalRequestLLA.post("UserInfo_/addTR", data);
export const C_UserInfo_UpdateUI = (data) => normalRequestLLA.post("UserInfo_/updateUI", data);

export const C_UserInfo_GetAllCertExpiryUser = () => normalRequestLLA.get("UserInfo_/certExpiry");
export const C_UserInfo_SendCertExpiryMail = () => normalRequestLLA.get("UserInfo_/certExpiryMail");

export const C_ExamMainLocation_GetList = () => normalRequestLLA.get("MainExamLocation_/list");
export const C_ExamMainLocation_Add = (data) => normalRequestLLA.post("MainExamLocation_", data);
export const C_ExamMainLocation_Delete = (id) => normalRequestLLA.delete(`MainExamLocation_/${id}`);
export const C_ExamMainLocation_Update = (data) => normalRequestLLA.put("MainExamLocation_", data);

export const C_ExamSubLocation_Delete = (id) => normalRequestLLA.delete(`SubExamLocation_/${id}`);
export const C_ExamSubLocation_Update = (data) => normalRequestLLA.put("SubExamLocation_", data);
export const C_ExamSubLocation_GetList = () => normalRequestLLA.get("SubExamLocation_/list/");

export const C_ExamSession_GetList = () => normalRequestLLA.get("ExamSession_/list/");
export const C_ExamSession_Get = (id) => normalRequestLLA.get(`ExamSession_/${id}`);
export const C_ExamSession_Add = (data) => normalRequestLLA.post("ExamSession_", data);
export const C_ExamSession_Update = (id, data) => normalRequestLLA.put(`ExamSession_/${id}`, data);
export const C_ExamSession_Delete = (id) => normalRequestLLA.delete(`ExamSession_/${id}`);
export const C_ExamSession_UpdateExamStatus = (id) => normalRequestLLA.put(`ExamSession_/status/${id}`);

export const C_ExamInfo_GetList = (sessionId) => normalRequestLLA.get(`ExamInfo_/list/${sessionId}`);
export const C_ExamInfo_UpdateList = (data) => normalRequestLLA.put("ExamInfo_/list/", data);
export const C_ExamInfo_ExamNumberRepeatSolve = (data) => normalRequestLLA.put("ExamInfo_/repeat/", data);
export const C_ExamInfo_ExportUrl = `${llaApiBaseUrl}ExamInfo_/export/`;

export const C_ExamInfo_GetBackUserList = (userId) => normalRequestLLA.get(`ExamInfo_/backUserList/${userId}`);
export const C_ExamInfo_DeleteList = (data) => normalRequestLLA.post("ExamInfo_/delete", data);

export const G_Linked_GetList = (categoryId) => normalRequest.get(`G_Linked_/list?categoryId=${categoryId}`);
export const G_Linked_Add = (data) => normalRequest.post("G_Linked_", data);
export const G_Linked_Update = (id, data) => normalRequest.put(`G_Linked_/${id}`, data);
export const G_Linked_Delete = (id) => normalRequest.delete(`G_Linked_/${id}`);
export const G_Linked_Sort = (data) => normalRequest.post("G_Linked_/sort", data);

export const G_Linked_Category_GetList = () => normalRequest.get("G_Linked_Category_/list");
export const G_Linked_Category_Add = (data) => normalRequest.post("G_Linked_Category_", data);
export const G_Linked_Category_Update = (id, data) => normalRequest.put(`G_Linked_Category_/${id}`, data);
export const G_Linked_Category_Delete = (id) => normalRequest.delete(`G_Linked_Category_/${id}`);
export const G_Linked_Category_Sort = (data) => normalRequest.post("G_Linked_Category_/sort", data);

export const G_Home_Carousel_Add = (data) => normalRequest.post("G_Home_Carousel_", data);
export const G_Home_Carousel_GetList = () => normalRequest.get("G_Home_Carousel_/list");
export const G_Home_Carousel_Delete = (id) => normalRequest.delete(`G_Home_Carousel_/${id}`);
export const G_Home_Carousel_Sort = (data) => normalRequest.post("G_Home_Carousel_/sort", data);

export const G_News_Category_GetList = () => normalRequest.get("G_News_Category_/list");

export const G_News_Add = (data) => normalRequest.post("G_News_", data);
export const G_News_GetList = (categoryId) => normalRequest.get(`G_News_/list?categoryId=${categoryId}`);
export const G_News_Update = (id, data) => normalRequest.put(`G_News_/${id}`, data);
export const G_News_Delete = (id) => normalRequest.delete(`G_News_/${id}`);

export const G_News_AlbumPicture_Add = (data) => normalRequest.post("G_News_AlbumPicture_", data);
export const G_News_AlbumPicture_GetList = (activityId) => normalRequest.get(`G_News_AlbumPicture_/list?newsId=${activityId}`);
export const G_News_AlbumPicture_Delete = (id) => normalRequest.delete(`G_News_AlbumPicture_/${id}`);
export const G_News_AlbumPicture_Sort = (data) => normalRequest.post("G_News_AlbumPicture_/sort", data);

export const G_Service_Dm_Add = (data) => normalRequest.post("G_Service_Dm_", data);
export const G_Service_Dm_GetList = () => normalRequest.get("G_Service_Dm_/list");
export const G_Service_Dm_Update = (id, data) => normalRequest.put(`G_Service_Dm_/${id}`, data);
export const G_Service_Dm_Delete = (id) => normalRequest.delete(`G_Service_Dm_/${id}`);
export const G_Service_Dm_Sort = (data) => normalRequest.post("G_Service_Dm_/sort", data);

export const G_ContactUs_GetList = () => normalRequest.get("G_ContactUs_/list");
export const G_ContactUs_Delete = (id) => normalRequest.delete(`G_ContactUs_/${id}`);

export const B_News_Category_GetList = () => normalRequest.get("B_News_Category_/list");

export const B_News_Add = (data) => normalRequest.post("B_News_", data);
export const B_News_GetList = (categoryId) => normalRequest.get(`B_News_/list?categoryId=${categoryId}`);
export const B_News_Update = (id, data) => normalRequest.put(`B_News_/${id}`, data);
export const B_News_Delete = (id) => normalRequest.delete(`B_News_/${id}`);

export const B_Home_Star_Add = (data) => normalRequest.post("B_Home_Star_", data);
export const B_Home_Star_GetList = () => normalRequest.get("B_Home_Star_/list");
export const B_Home_Star_Delete = (id) => normalRequest.delete(`B_Home_Star_/${id}`);
export const B_Home_Star_Sort = (data) => normalRequest.post("B_Home_Star_/sort", data);

export const B_AboutUs_Background_AttachmentFile_Add = (data) => normalRequest.post("B_AboutUs_Background_AttachmentFile_", data);
export const B_AboutUs_Background_AttachmentFile_GetList = () => normalRequest.get("B_AboutUs_Background_AttachmentFile_/list");
export const B_AboutUs_Background_AttachmentFile_Update = (id, data) => normalRequest.put(`B_AboutUs_Background_AttachmentFile_/${id}`, data);
export const B_AboutUs_Background_AttachmentFile_Delete = (id) => normalRequest.delete(`B_AboutUs_Background_AttachmentFile_/${id}`);

export const B_AboutUs_Increase_AttachmentFile_Add = (data) => normalRequest.post("B_AboutUs_Increase_AttachmentFile_", data);
export const B_AboutUs_Increase_AttachmentFile_GetList = () => normalRequest.get("B_AboutUs_Increase_AttachmentFile_/list");
export const B_AboutUs_Increase_AttachmentFile_Update = (id, data) => normalRequest.put(`B_AboutUs_Increase_AttachmentFile_/${id}`, data);
export const B_AboutUs_Increase_AttachmentFile_Delete = (id) => normalRequest.delete(`B_AboutUs_Increase_AttachmentFile_/${id}`);

export const B_AboutUs_Increase_Video_Add = (data) => normalRequest.post("B_AboutUs_Increase_Video_", data);
export const B_AboutUs_Increase_Video_GetList = () => normalRequest.get("B_AboutUs_Increase_Video_/list");
export const B_AboutUs_Increase_Video_Update = (id, data) => normalRequest.put(`B_AboutUs_Increase_Video_/${id}`, data);
export const B_AboutUs_Increase_Video_Delete = (id) => normalRequest.delete(`B_AboutUs_Increase_Video_/${id}`);

export const B_AdvantageProduct_Add = (data) => normalRequest.post("B_AdvantageProduct_", data);
export const B_AdvantageProduct_GetList = (categoryId) => normalRequest.get(`B_AdvantageProduct_/list?categoryId=${categoryId}`);
export const B_AdvantageProduct_Update = (id, data) => normalRequest.put(`B_AdvantageProduct_/${id}`, data);
export const B_AdvantageProduct_Delete = (id) => normalRequest.delete(`B_AdvantageProduct_/${id}`);
export const B_AdvantageProduct_Sort = (data) => normalRequest.post("B_AdvantageProduct_/sort", data);

export const B_HonorSystem_System_Add = (data) => normalRequest.post("B_HonorSystem_System_", data);
export const B_HonorSystem_System_GetList = () => normalRequest.get("B_HonorSystem_System_/list");
export const B_HonorSystem_System_Update = (id, data) => normalRequest.put(`B_HonorSystem_System_/${id}`, data);
export const B_HonorSystem_System_Delete = (id) => normalRequest.delete(`B_HonorSystem_System_/${id}`);

export const B_HonorSystem_Rank_Month_Add = (data) => normalRequest.post("B_HonorSystem_Rank_Month_", data);
export const B_HonorSystem_Rank_Month_GetList = (type) => normalRequest.get(`B_HonorSystem_Rank_Month_/list?type=${type}`);
export const B_HonorSystem_Rank_Month_Update = (id, data) => normalRequest.put(`B_HonorSystem_Rank_Month_/${id}`, data);
export const B_HonorSystem_Rank_Month_Delete = (id) => normalRequest.delete(`B_HonorSystem_Rank_Month_/${id}`);

export const B_HonorSystem_Rank_Year_Add = (data) => normalRequest.post("B_HonorSystem_Rank_Year_", data);
export const B_HonorSystem_Rank_Year_GetList = () => normalRequest.get("B_HonorSystem_Rank_Year_/list");
export const B_HonorSystem_Rank_Year_Update = (id, data) => normalRequest.put(`B_HonorSystem_Rank_Year_/${id}`, data);
export const B_HonorSystem_Rank_Year_Delete = (id) => normalRequest.delete(`B_HonorSystem_Rank_Year_/${id}`);

export const B_HonorSystem_Rank_History_Add = (data) => normalRequest.post("B_HonorSystem_Rank_History_", data);
export const B_HonorSystem_Rank_History_GetList = () => normalRequest.get("B_HonorSystem_Rank_History_/list");
export const B_HonorSystem_Rank_History_Update = (id, data) => normalRequest.put(`B_HonorSystem_Rank_History_/${id}`, data);
export const B_HonorSystem_Rank_History_Delete = (id) => normalRequest.delete(`B_HonorSystem_Rank_History_/${id}`);

export const B_Activity_Add = (data) => normalRequest.post("B_Activity_", data);
export const B_Activity_GetList = (categoryId) => normalRequest.get(`B_Activity_/list?categoryId=${categoryId}`);
export const B_Activity_Update = (id, data) => normalRequest.put(`B_Activity_/${id}`, data);
export const B_Activity_Delete = (id) => normalRequest.delete(`B_Activity_/${id}`);
export const B_Activity_Sort = (data) => normalRequest.post("B_Activity_/sort", data);

export const B_Activity_AlbumPicture_Add = (data) => normalRequest.post("B_Activity_AlbumPicture_", data);
export const B_Activity_AlbumPicture_GetList = (activityId) => normalRequest.get(`B_Activity_AlbumPicture_/list?activityId=${activityId}`);
export const B_Activity_AlbumPicture_Delete = (id) => normalRequest.delete(`B_Activity_AlbumPicture_/${id}`);
export const B_Activity_AlbumPicture_Sort = (data) => normalRequest.post("B_Activity_AlbumPicture_/sort", data);

export const B_TrainingSystem_Add = (data) => normalRequest.post("B_TrainingSystem_", data);
export const B_TrainingSystem_GetList = (categoryId) => normalRequest.get(`B_TrainingSystem_/list?categoryId=${categoryId}`);
export const B_TrainingSystem_Update = (id, data) => normalRequest.put(`B_TrainingSystem_/${id}`, data);
export const B_TrainingSystem_Delete = (id) => normalRequest.delete(`B_TrainingSystem_/${id}`);
export const B_TrainingSystem_Sort = (data) => normalRequest.post("B_TrainingSystem_/sort", data);

export const B_LawCompliance_Add = (data) => normalRequest.post("B_LawCompliance_", data);
export const B_LawCompliance_GetList = (categoryId) => normalRequest.get(`B_LawCompliance_/list?categoryId=${categoryId}`);
export const B_LawCompliance_Update = (id, data) => normalRequest.put(`B_LawCompliance_/${id}`, data);
export const B_LawCompliance_Delete = (id) => normalRequest.delete(`B_LawCompliance_/${id}`);
export const B_LawCompliance_Sort = (data) => normalRequest.post("B_LawCompliance_/sort", data);

export const CheckAdminLogin = () => axios.get(`${normalApiBaseUrl}Admin/CheckLogin`, { withCredentials: true });
export const AdminLogin = (data) => axios.post(`${normalApiBaseUrl}Admin/Login`, data, { withCredentials: true });
export const AdminLogout = () => axios.get(`${normalApiBaseUrl}Admin/Logout`, { withCredentials: true });
export const CaptchaImage_Get = () => `${normalApiBaseUrl}Captcha`;
